export default __webpack_public_path__ + "static/media/KOD0023-min.8bd5ff96.webp";